/**
 * @example
 * <dpw-protected-feature is-accessible="ctrl.isAccessible">
 *     <button type="submit"
 *             class="button" ng-class="ctrl.isAccessible ? 'button-orange' : 'button-disabled'"
 *             ng-disabled="!ctrl.isAccessible">
 *        Submit
 *     </button>
 * </dpw-protected-feature>
 */
angular.module('dpw.components').component('dpwProtectedFeature', {
    bindings: {
        isAccessible: '<',
        message: '@?'
    },
    templateUrl: 'dpw-protected-feature.html',
    transclude: true,
    controllerAs: 'ctrl',
    controller: [function () {
        this.getMsgContent = function () {
            return this.message || RCDPW.Lang.MyAccount.RolePermission.NO_PERMISSION;
        };
    }]
});
